import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import theme from './theme';
import './index.css';
import TemporaryDownPage from './siteDown';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const IS_SITE_DOWN = false;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {IS_SITE_DOWN ? (
      <TemporaryDownPage />
    ) : (
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </QueryClientProvider>
    )}
  </React.StrictMode>
);
